import React, { useMemo } from 'react';
import { useTheme } from '@emotion/react';
import { useParams } from 'react-router-dom';
import { useContacts } from '@app/hooks';
import Header from '@components/Header';
import ContactItem from '@components/ContactItem';
import ContactOverlay from '@components/ContactOverlay';
import { Title } from './styles';
import useBlockScroll from '@app/hooks/useBlockScroll';
import routes from '@routes';
import Wrapper from '@components/Wrapper';
import { PAGE_PADDING_TOP } from '@constants';

const ContactsPage = () => {
  const theme = useTheme();
  const { contactSlug } = useParams<{ contactSlug: string }>();

  const { contacts } = useContacts();

  const selectedContact = useMemo(
    () => contacts.find((contact) => contact?.urlSlug === contactSlug),
    [contacts, contactSlug]
  );

  useBlockScroll(!!selectedContact);

  const customCfg = {
    route: routes.CONTACTS(),
    visible: true,
    transparent: false,
    hideBurger: true,
    logoColor: theme.colors.primaryBlue,
  };

  return (
    <>
      <Header customCfg={customCfg} />
      <Wrapper padding={`${PAGE_PADDING_TOP}px 20px 20px`}>
        <Title>Nokia Contacts</Title>
        {contacts.length > 0 ? (
          <>
            {contacts.map((contact, idx: number) => (
              <React.Fragment key={contact.email}>
                <ContactItem {...contact} isFirst={idx === 0} />
              </React.Fragment>
            ))}
          </>
        ) : null}
        {selectedContact && <ContactOverlay {...selectedContact} />}
      </Wrapper>
    </>
  );
};

export default ContactsPage;
